import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutline";
import { alpha } from "@mui/material/styles";
export function ChannelToggle({ value, onChange, channels, disabled, labels, }) {
    if (channels.length < 2)
        return null;
    return (_jsxs(ToggleButtonGroup, { exclusive: true, fullWidth: true, value: value, onChange: (_, next) => next && onChange(next), "aria-label": labels.group, sx: (theme) => ({
            p: 0.5,
            gap: 0.5,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.text.primary, 0.04),
            "& .MuiToggleButton-root": {
                border: 0,
                borderRadius: 1.5,
                py: 1,
                gap: 0.75,
                fontSize: 14,
                fontWeight: 600,
                textTransform: "none",
                color: theme.palette.text.secondary,
                "&:hover": {
                    backgroundColor: alpha(theme.palette.text.primary, 0.04),
                },
                "&.Mui-selected": {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.background.paper,
                    boxShadow: `0 1px 2px ${alpha("#0f172a", 0.08)}, 0 1px 3px ${alpha("#0f172a", 0.06)}`,
                    "&:hover": { backgroundColor: theme.palette.background.paper },
                },
                "& svg": { fontSize: 18 },
            },
        }), children: [_jsxs(ToggleButton, { value: "phone", disabled: disabled, children: [_jsx(ChatBubbleOutlineRoundedIcon, {}), labels.whatsapp] }), _jsxs(ToggleButton, { value: "email", disabled: disabled, children: [_jsx(MailOutlineRoundedIcon, {}), labels.email] })] }));
}
